import {Form} from 'antd'
import meta from './metaOm.mjs'
import Select from './SelectOm.jsx'

export const FormItemOm = props => (
    <Form.Item
        label={meta.name}
        name="om"
        {...props}
    >
        <Select />
    </Form.Item>
)

export const FormItemOms = props => (
    <Form.Item
        label={meta.name}
        name="oms"
        {...props}
    >
        <Select multiple />
    </Form.Item>
)
